import React, { useEffect, useState } from "react";
import { Form, Button, Switch } from "antd";
import { useNavigate } from "react-router-dom";
import { MyColor } from "../../config/myStyle";
import { FormRequiredMark } from "../../components/FormRequiredMark";
import { MyInput } from "../../components/MyInput";
import { MyInputPassword } from "../../components/MyInputPassword";
import { authStore, userStore } from "../../stores";
import PageBox from "../../layout/PageBox";
import { observer } from "mobx-react-lite";
import LoginPasscode from "./LoginPasscode";
import { useTranslation } from "react-i18next";

const Login = observer(() => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [stayLogged, setStayLogged] = useState(false);
  const [loginPasscodeModal, setLoginPasscodeModal] = useState<{ open: boolean; key?: any }>();

  useEffect(() => {
    if (authStore.sendCodeStatus.status === 200) {
      authStore.resetSendCodeStatus()
      setLoginPasscodeModal({
        open: true,
        key: Date.now()
      })
    }
  }, [authStore.sendCodeStatus.status])

  useEffect(() => {
    if (authStore.loginStatus.status === 200) {
      authStore.resetLoginStatus()
      userStore.getUser()
    }
  }, [authStore.loginStatus.status])

  useEffect(() => {
    if (userStore.userStatus.status === 200) {
      userStore.resetUserStatus()
      navigate('/')
    }
  }, [userStore.userStatus.status])

  const onFinish = async (values: any) => {
    await authStore.sendVerificationCode({
      type: 'login',
      username: values.username,
    })
  };

  const onPasscode = async (passcode: string) => {
    const password = form.getFieldValue("password");
    const username = form.getFieldValue("username");
    const rememberMe = form.getFieldValue("rememberMe");
    setLoginPasscodeModal({
      open: false
    })
    authStore.login({
      passcode,
      password,
      username,
      rememberMe: Boolean(rememberMe),
    })
  };

  return (
    <PageBox spinning={authStore.sendCodeStatus.loading || authStore.loginStatus.loading || userStore.userStatus.loading}>
      <div className="flex-col m-[18px] bg-white rounded-[20px] px-[24px] pt-[30px] pb-[32px]">
        <div className="text-[20px] font-[400] mb-[32px]" style={{ color: MyColor.blue }}>
          {t("login.welcome_back")}
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          requiredMark={FormRequiredMark}
        >
          {/* Login */}
          <Form.Item
            label={t("login.login")}
            name="username"
            rules={[
              { required: true, message: t("login.please_enter_username") }
            ]}
          >
            <MyInput placeholder={t("login.placeholder_login")} style={{ backgroundColor: MyColor.bg }} />
          </Form.Item>
          {/* Password */}
          <Form.Item
            label={t("login.password")}
            name="password"
            rules={[
              { required: true, message: t("login.please_enter_password") }
            ]}
          >
            <MyInputPassword placeholder={t("login.placeholder_password")} style={{ backgroundColor: MyColor.bg }} />
          </Form.Item>
          {/* Stay logged in & Forgot Password */}
          <div className="flex items-center justify-between mt-[-6px] mb-[20px]">
            <div className="flex items-center">
              <Form.Item name="rememberMe">
                <Switch
                  checked={stayLogged}
                  onChange={setStayLogged}
                  size="small"
                  style={{
                    background: stayLogged ? MyColor.blue : "#ddd",
                    marginRight: 9,
                    marginTop: 2,
                  }}
                />
              </Form.Item>
              <span className="text-[16px]" style={{ color: "#444", opacity: 0.7 }}>{t("login.stay_logged_in")}</span>
            </div>
            <div
              className="text-[16px] cursor-pointer"
              style={{ color: MyColor.blue, opacity: 0.7 }}
              onClick={() => navigate("/forgot-password")}
            >
              {t("login.forget_password")}
            </div>
          </div>
          {/* 登录按钮 */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                width: "100%",
                borderRadius: 30,
                background: "#BE9E73",
                border: "none",
                height: 48,
                fontSize: 20,
                color: "white",
                fontWeight: 500,
                marginTop: 10,
                marginBottom: 26,
                letterSpacing: 1,
              }}
            >
              {t("login.login_button")}
            </Button>
          </Form.Item>
          {/* 分割线 */}
          <div style={{ borderTop: "1px solid #eceae6", margin: "24px 0 18px 0" }} />
          {/* 注册引导 */}
          <div className="text-[13px] text-[#969696] mb-[12px] text-center">
            {t("login.not_registered_yet")}
          </div>
          <Button
            type="default"
            style={{
              width: "100%",
              borderRadius: 30,
              background: MyColor.red,
              color: "#fff",
              height: 48,
              fontSize: 20,
              fontWeight: 500,
              marginTop: 8,
              letterSpacing: 1,
              border: "none",
              boxShadow: "0 2px 8px #eecbe0"
            }}
            onClick={() => navigate("/register/form-a")}
          >
            {t("login.register")}
          </Button>
        </Form>
      </div>
      <LoginPasscode
        key={loginPasscodeModal?.key}
        modalProps={{
          open: loginPasscodeModal?.open,
          onCancel: () => setLoginPasscodeModal({ open: false }),
        }}
        onPasscode={onPasscode}
      />
    </PageBox>
  );
})

export default Login;
